import { Configuration } from '../../retool_client'
import { customComponentSupportLibraryVersion } from '../../version'
import { UrlAndAccessToken } from './accessTokens'
import { CustomComponentLibraryWrappedClient } from '../../customComponentLibraryWrappedClient'
import { ApiError } from '../../apiError'
import { parseHeaders } from '../../getCCLClient'

export const testConnection = async (credentials: UrlAndAccessToken & { headers: string[] }) => {
  const { url, accessToken, unixSocket } = credentials

  const headersToUse = {
    'X-Retool-Client-Version': `custom-component-support-${customComponentSupportLibraryVersion}`,
  }

  const givenHeaders = parseHeaders(credentials.headers)
  givenHeaders?.forEach((h) => {
    headersToUse[h.name] = h.value
  })
  const configuration = new Configuration({
    basePath: `${url}/api/v2`,
    accessToken: accessToken,
    headers: headersToUse
  })
  const api = new CustomComponentLibraryWrappedClient(configuration, unixSocket)
  try {
    await api.customComponentLibrariesGet()
  } catch (e) {
    if (e instanceof ApiError) return e.errorMessage
  }
  return undefined
}
